/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Warmup_Method_RampInputs */

const en_us2_workout_logging_warmup_method_ramp = /** @type {(inputs: Workout_Logging_Warmup_Method_RampInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ramp`)
};

const pt_br2_workout_logging_warmup_method_ramp = /** @type {(inputs: Workout_Logging_Warmup_Method_RampInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rampa`)
};

const es_419_workout_logging_warmup_method_ramp = /** @type {(inputs: Workout_Logging_Warmup_Method_RampInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rampa`)
};

const pt_pt2_workout_logging_warmup_method_ramp = /** @type {(inputs: Workout_Logging_Warmup_Method_RampInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rampa`)
};

const fr_fr2_workout_logging_warmup_method_ramp = /** @type {(inputs: Workout_Logging_Warmup_Method_RampInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progressif`)
};

const de_de2_workout_logging_warmup_method_ramp = /** @type {(inputs: Workout_Logging_Warmup_Method_RampInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rampe`)
};

const it_it2_workout_logging_warmup_method_ramp = /** @type {(inputs: Workout_Logging_Warmup_Method_RampInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progressivo`)
};

/**
* | output |
* | --- |
* | "Ramp" |
*
* @param {Workout_Logging_Warmup_Method_RampInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_warmup_method_ramp = /** @type {((inputs?: Workout_Logging_Warmup_Method_RampInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Warmup_Method_RampInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_warmup_method_ramp(inputs)
	if (locale === "es-419") return es_419_workout_logging_warmup_method_ramp(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_warmup_method_ramp(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_warmup_method_ramp(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_warmup_method_ramp(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_warmup_method_ramp(inputs)
	return en_us2_workout_logging_warmup_method_ramp(inputs)
});
export { workout_logging_warmup_method_ramp as "workout-logging.warmup_method_ramp" }